import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import { FOOTBALL_ONBOARDING_SELECT_COMPETITION } from '@sorare/core/src/constants/__generated__/routes';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { glossary } from '@sorare/core/src/lib/glossary';

import { CommonMode } from '@sorare/gameplay/src/components/commonGame/CommonMode';

type Props = {
  leagueSlug?: string;
};
export const BackToCommon = ({ leagueSlug }: Props) => {
  const track = useEvents();

  const navigate = useNavigate();

  const handleSelect = async () => {
    track('Click Common In Guidance First Lineup', {});
    navigate(
      `${FOOTBALL_ONBOARDING_SELECT_COMPETITION}?relock=true&leagueSlug=${leagueSlug}`
    );
  };

  return (
    <CommonMode hideSelect selected={false} onSelect={handleSelect}>
      <Vertical center>
        <OnboardingButton
          color="secondary"
          size="medium"
          style={{
            pointerEvents: 'none',
          }}
        >
          <FormattedMessage {...glossary.playNow} />
        </OnboardingButton>
      </Vertical>
    </CommonMode>
  );
};
